var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightbulbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_167_764)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 8,
    fill: "#29AA43",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 7.5,
    stroke: "#29AA43"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.838 36.8765C24.6489 35.9478 23.6858 34.7616 23.0211 33.4072C22.3564 32.0527 22.0073 30.5652 22.0002 29.0565C21.9702 23.6362 26.34 19.1304 31.7589 19.0029C33.8587 18.9523 35.9212 19.5642 37.6537 20.7518C39.3862 21.9393 40.7008 23.6423 41.411 25.619C42.1212 27.5957 42.191 29.7459 41.6104 31.7645C41.0299 33.7831 39.8284 35.5677 38.1766 36.8651C37.8127 37.147 37.5178 37.5079 37.3139 37.9205C37.1101 38.3332 37.0028 38.7868 37 39.247L37 40.0001C37 40.2653 36.8947 40.5196 36.7071 40.7072C36.5196 40.8947 36.2652 41.0001 36 41.0001H28C27.7348 41.0001 27.4804 40.8947 27.2929 40.7072C27.1053 40.5196 27 40.2653 27 40.0001L27 39.2462C26.9988 38.7889 26.8936 38.3379 26.6923 37.9273C26.491 37.5167 26.1988 37.1574 25.838 36.8765Z",
    fill: "#00A2E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 45H37",
    stroke: "#00A2E9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 41V34",
    stroke: "#00A2E9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 30L32 34L36 30",
    stroke: "#00A2E9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.838 36.8765C24.6489 35.9478 23.6858 34.7616 23.0211 33.4072C22.3564 32.0527 22.0073 30.5652 22.0002 29.0565C21.9702 23.6362 26.34 19.1304 31.7589 19.0029C33.8587 18.9523 35.9212 19.5642 37.6537 20.7518C39.3862 21.9393 40.7008 23.6423 41.411 25.619C42.1212 27.5957 42.191 29.7459 41.6104 31.7645C41.0299 33.7831 39.8284 35.5677 38.1766 36.8651C37.8127 37.147 37.5178 37.5079 37.3139 37.9205C37.1101 38.3332 37.0028 38.7868 37 39.247L37 40.0001C37 40.2653 36.8947 40.5196 36.7071 40.7072C36.5196 40.8947 36.2652 41.0001 36 41.0001H28C27.7348 41.0001 27.4804 40.8947 27.2929 40.7072C27.1053 40.5196 27 40.2653 27 40.0001L27 39.2462C26.9988 38.7889 26.8936 38.3379 26.6923 37.9273C26.491 37.5167 26.1988 37.1574 25.838 36.8765V36.8765Z",
    stroke: "#00A2E9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_167_764",
    x: -16,
    y: -16,
    width: 96,
    height: 96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_167_764"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_167_764",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulbIcon);
export default __webpack_public_path__ + "static/media/lightbulb-icon.4b31b927d0e20a0f765d6daa5e5bc272.svg";
export { ForwardRef as ReactComponent };